// src/components/signal/TermsPanel.tsx
import React from "react";
import { useTranslation } from "react-i18next";

// 안전 t 헬퍼
const tSafe = (t: any, key: string, def = ""): string => {
  const v: any = t(key as any, def as any);
  return typeof v === "string" ? v : (v?.tag ?? def ?? key);
};

const TermsPanel: React.FC = () => {
  // ✅ signal 하나만 사용
  const { t } = useTranslation("signal");

  const items = [
    "atr","ema","rr","sl","tp","pivot","fib","conf","mom","wall",
    "cnf","riskp","lev","notional","pnl","rsi","macd","reversal","riskm","volreg"
  ];

  return (
    <div className="card">
      <div className="card-head neon">
        {tSafe(t, "terms.title", "Glossary / Guide")}
      </div>

      {/* 면책문구(고지) */}
      <section className="card-section">
        <div className="section-head">
          {tSafe(t, "terms.notice.title", "Disclaimer")}
        </div>
        <p className="muted">
          {tSafe(t, "terms.notice.line1", "Crypto derivatives carry high risk. You may lose your capital.")}<br/>
          {tSafe(t, "terms.notice.line2", "Educational purpose only, not financial advice.")}<br/>
          {tSafe(t, "terms.notice.line3", "Always manage your risk and size properly.")}
        </p>
      </section>

      {/* 용어집 */}
      <section className="card-section">
        <div className="section-head">
          {tSafe(t, "terms.glossaryTitle", "Trading Glossary")}
        </div>
        <div className="grid">
          {items.map((k) => (
            <div key={k} className="term">
              <h4 className="term-title">
                {tSafe(t, `terms.glossary.${k}.title`, k.toUpperCase())}
              </h4>
              <p className="term-desc">
                {tSafe(t, `terms.glossary.${k}.desc`, "")}
              </p>
            </div>
          ))}
        </div>
      </section>

      <style>{`
        .card-section { border:1px solid #2a2f3a; border-radius:12px; background:#10141c; padding:14px; margin-bottom:10px; }
        .section-head { font-weight:900; color:#cfe1ff; margin-bottom:8px; }
        .muted { color:#9fb1c3; font-size:13px; line-height:1.6; margin-bottom:12px; }
        .grid { display:grid; grid-template-columns:repeat(2,1fr); gap:12px; }
        .term { background:#111827; border:1px solid #1f2a3b; border-radius:10px; padding:12px; }
        .term-title { font-weight:800; color:#22d3ee; font-size:14px; margin-bottom:6px; }
        .term-desc { font-size:13px; color:#d1d5db; line-height:1.5; }
        @media (max-width:768px){ .grid { grid-template-columns:1fr; } }
      `}</style>
    </div>
  );
};

export default TermsPanel;
